import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@hooks";
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useDeleteCategory = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  const deleteCategory = async (id: string) => {
    try {
      await axios.delete(`/api/categories/${id}`);
    } catch (error) {
      throw new Error(t("messages.error.categoryDelete"));
    }
  };

  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      message.success(t("messages.success.deleteCategory"));
    },
  });
};
